import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { SignIn } from "@phosphor-icons/react";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@epas.network");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="relative w-full max-w-md bg-white p-10 border border-black/5 shadow-2xl">
        <div className="mb-8">
          <Logo size="md" asLink={false} showTagline={false} testId="login-logo" />
          <div className="mt-2 text-[10px] uppercase tracking-[0.24em] text-navy/50">Network Operator</div>
        </div>
        <h1 className="font-display text-3xl font-bold text-navy tracking-tight">Admin sign in</h1>
        <p className="text-sm text-navy/60 mt-2">Operator access only.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="overline mb-2 block">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-black/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-navy"
              required
            />
          </div>
          <div>
            <label className="overline mb-2 block">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-black/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-navy"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="btn-primary w-full justify-center"
          >
            <SignIn size={16} />
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-[11px] text-navy/50 leading-relaxed">
          Default seeded admin: <span className="font-mono">admin@epas.network</span>.
          Password provided in environment (<span className="font-mono">ADMIN_PASSWORD</span>).
        </p>
      </div>
    </div>
  );
}
